<template>
	<div class="upload-wrapper d-flex col-7">
		<label
			class="upload-box"
			for="myFile"
			:class="{'upload-box-border': this.file}"
		>
			<div v-if="file">
				<img class="uploaded-img">
				<span class="drop-zone-prompt">
					Uploaded File: {{file.name}}	
				</span>
			</div>
			<div v-else>
				<img class="upload-cloud-img">
				<span class="drop-zone-prompt">
					Drop a file or <span class="browse-btn">browse</span>
				</span>
			</div>
			<input class="drop-zone-input" type="file" id="myFile" name="send_file" @change="onFileChange">
		</label>
	</div>
</template>

<script>
export default {
	name: 'Upload',
	data() {
		return {
			file: null,
		}
	},
	methods: {
		onFileChange(e) {
			const file = e.target.files || e.dataTransfer.files;

			if(file && file[0].size < 16777216){
				this.file = file[0]
				this.$emit('selected', this.file)
			} else {
				alert("File size exceeds the limit of 16MB")
			}
			
		},
	},

}
</script>